import { MobileOS } from '@enums/DeviceInfoType';
import { Resolutions } from '@enums/Resolutions';
import { getDeviceInfo } from '@services/utils/CheckDeviceCompatibility';
import { useEffect, useState } from 'react';
import useWindowDimensions from './UseWindowDimensions';

export const useCheckDevice = () => {
  const [isLandScape, setIsLandScape] = useState<boolean>(false);

  const { width } = useWindowDimensions();
  const { deviceOS } = getDeviceInfo();

  const userAgent = navigator.userAgent;

  const checkMobileDevice = (): boolean => {
    if (
      checkIfPwa() &&
      checkDesktopMode() &&
      !window.location.href.includes('pwaDesktopModeError')
    ) {
      window.location.href = 'pwaDesktopModeError';
    }

    setIsLandScape(window.matchMedia('(orientation: landscape)').matches);

    if (navigator.userAgent.match(/iPhone/i)) {
      return true;
    }
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i) ||
      (width < Resolutions.Tablet &&
        window.matchMedia('(orientation: portrait)').matches &&
        !(navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/Macintosh/i))) //For iPad Mini
    ) {
      if (
        (window.matchMedia('(orientation: portrait)').matches &&
          window.innerWidth >= Resolutions.Tablet) ||
        (window.matchMedia('(orientation: landscape)').matches &&
          window.innerHeight > Resolutions.MobileLandscape)
      ) {
        return false;
      }

      return true;
    }
    return false;
  };

  const checkTabletDevice = (): boolean => {
    if (
      navigator.userAgent.match(/iPad/i) ||
      ((navigator.platform === 'MacIntel' || navigator.platform === 'Macintosh') &&
        navigator.maxTouchPoints > 2) ||
      (((window.matchMedia('(orientation: portrait)').matches &&
        window.innerWidth >= Resolutions.Tablet) ||
        (window.matchMedia('(orientation: landscape)').matches &&
          window.innerHeight > Resolutions.MobileLandscape)) &&
        width < Resolutions.Desktop)
    ) {
      return true;
    }
    return false;
  };

  const checkDesktopMode = (): boolean => {
    if (
      (width < Resolutions.Tablet && window.matchMedia('(orientation: portrait)').matches) ||
      (window.innerHeight < Resolutions.MobileLandscape &&
        !window.matchMedia('(orientation: portrait)').matches)
    ) {
      if (deviceOS === MobileOS.IOS && checkTabletDevice()) {
        return true;
      } else if (
        (window.innerWidth > window.outerWidth * 1.4 &&
          window.matchMedia('(orientation: portrait)').matches) ||
        (window.innerWidth > window.outerWidth * 1.15 &&
          !window.matchMedia('(orientation: portrait)').matches)
      ) {
        return true;
      } else {
        return false;
      }
    }

    return false;
  };

  const checkIfPwa = (): boolean => {
    if (window.matchMedia('(display-mode: standalone)').matches) {
      return true;
    }
    return false;
  };

  const [isMobileDevice, setIsMobileDevice] = useState<boolean>(checkMobileDevice);
  const [isTabletDevice, setIsTabletDevice] = useState<boolean>(checkTabletDevice);
  const [isDesktopMode, setIsDesktopMode] = useState<boolean>(checkDesktopMode);

  useEffect(() => {
    setIsMobileDevice(checkMobileDevice);
    setIsTabletDevice(checkTabletDevice);
  }, [width, userAgent]);

  return { isMobileDevice, isTabletDevice, isLandScape, isDesktopMode };
};
